const SearchIcon = () => (
  <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.4971 1.5C15.2106 1.50015 19.0312 5.30567 19.0312 10C19.0312 11.9226 18.3892 13.6951 17.3086 15.1191L23.3848 21.1699C23.8609 21.6442 23.8607 22.4133 23.3848 22.8877C22.9084 23.3621 22.1356 23.3621 21.6592 22.8877L15.5762 16.8301C14.1569 17.8788 12.4001 18.4999 10.4971 18.5C5.78338 18.5 1.96191 14.6944 1.96191 10C1.96191 5.30558 5.78338 1.5 10.4971 1.5ZM10.5322 3.33203C6.81095 3.33209 3.79395 6.33688 3.79395 10.043C3.79396 13.749 6.81095 16.7538 10.5322 16.7539C14.2535 16.7539 17.2705 13.7491 17.2705 10.043C17.2705 6.33685 14.2536 3.33203 10.5322 3.33203Z"
      fill="var(--neutral-900)"
    />
  </svg>
);

export default SearchIcon;
